<template>
  <progress
    v-if="!marketsAvailable || !siteAvailable"
    class="progress is-small is-primary"
    max="100"
    >Fetching</progress
  >
  <div v-else>
    <!-- <script v-html="jsonld" type="application/ld+json"></script> -->
    <div class="columns is-vcentered">
      <div class="column is-narrow">
        <figure>
          <p class="image is-64x64">
            <img
              :src="'https://my.biddingmate.com.au/logos/' + site.site + '.png'"
              style="border-radius:10rem"
              :alt="site.sitename"
            />
          </p>
        </figure>
      </div>
      <div class="column">
        <h1 class="title">
          {{ site.sitename }}
        </h1>
        <h2 class="subtitle">{{ site.location }}</h2>
        <div class="tags">
          <span class="tag is-success"><a href="#">Cattle Market</a></span>
          <span class="tag is-success"><a href="#">Fat Market</a></span>
          <span class="tag is-success"><a href="#">Livestock</a></span>
        </div>
      </div>
    </div>

    <div class="block content mb-6" style="white-space: pre-wrap;">
      {{ site.profileText }}
    </div>
    <h2 v-if="marketsFiltered.length > 0" class="title">Next auction</h2>
    <div v-if="marketsFiltered.length > 0" class="upnext mb-6">
      <div
        class="columns is-vcentered"
        v-for="(market, index) in marketsFiltered"
        :key="index"
      >
        <div class="column">
          <div class="content">
            <p>
              <router-link :to="'/market/' + market.saleId" class="subtitle">{{
                market.saleDescription
              }}</router-link>
              <br />
              <small
                >{{ site.location }} |
                {{ market.scheduled.toLocaleString() }}</small
              >
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <a
            class="button is-white is-radiusless"
            :href="'/market/' + market.saleId"
            >VIEW</a
          >
        </div>
      </div>
    </div>

    <h2 class="title">Agents</h2>
    <figure class="stacked-imgs mb-6">
      <!-- <span v-for="(p, index) in agents" :key="index" class="stacked">
        <img
          :src="'https://my.biddingmate.com.au/logos/' + p.site + '.png'"
          class="image is-64x64"
        />
      </span> -->

      <a href="/agent/nashy" class="stacked">
        <span class="tag is-dark">Sonny</span>
        <img
          src="https://www.prostock.com.au/wp-content/uploads/Pro-Stock-Headshots-edit-4550-300x199.jpg"
          class="image is-128x128"
        />
      </a>

      <a href="/agent/nashy" class="stacked">
        <span class="tag is-dark">Gregg Nash</span>
        <img
          src="https://www.prostock.com.au/wp-content/uploads/Greg.jpg"
          class="image is-128x128"
        />
      </a>

      <a href="/agent/nashy" class="stacked">
        <span class="tag is-dark">Scott Richards</span>
        <img
          src="https://www.prostock.com.au/wp-content/uploads/Scott-R.jpg"
          class="image is-128x128"
        />
      </a>
    </figure>

    <h2 class="title">Contact</h2>
    <div class="columns">
      <div class="column is-half">
        <div class="content">
          <p>
            {{ site.contactPerson
            }}<span v-if="site.contactTitle.length > 0">
              - {{ site.contactTitle }}</span
            ><br />
            {{ site.contactPhone }}<br />
            <a :href="site.website" target="_blank" rel="noreferrer noopener"
              >{{ site.website }} <i class="zmdi zmdi-open-in-new"></i
            ></a>
          </p>

          <p>
            {{ site.siteAddress.address }},<br />
            {{ site.siteAddress.town }}, {{ site.siteAddress.postcode }}<br />
          </p>
        </div>
      </div>
      <div class="column">
        <iframe
          width="100%"
          style="border:0;height:350px"
          loading="lazy"
          allowfullscreen
          :src="
            'https://www.google.com/maps/embed/v1/place?key=AIzaSyAvPozVGRbHuxqcMyev1HBN-vDO1iMJzAE&maptype=satellite&q=' +
              gpsAddress
          "
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<style scoped>
.upnext {
  background-color: #17784d;
  border-radius: 12px;
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
  position: relative;
}
.stacked-imgs {
  display: inline-flex;
  flex-direction: row-reverse;
  transform: scale(-1, 1);
}

.stacked {
  position: relative;
  overflow: hidden;
}

/* .stacked:not(:last-child) {
  margin-left: -2.5rem;
} */

.stacked img {
  display: block;
  transform: scale(-1, 1);
  border: 4px solid #161a25;
  border-radius: 50%;
}
.stacked-imgs .tag {
  position: fixed;
  transform: scale(-1, 1);
  bottom: 0;
  z-index: 1;
}
</style>

<script>
import log from 'loglevel'
import { proapps } from '../common/proapps'

export default {
  name: 'MarketSite',
  metaInfo() {
    return {
      title: this.site.sitename,
      meta: [
        {
          name: 'description',
          content: this.site.sitename
        }
      ]
    }
  },
  components: {},
  data() {
    const jsonld = {
      '@context': 'http://schema.org/',
      '@type': 'Code',
      name: this.name,
      description: 'Declarative JSON-LD Structured Data for Vue App',
      discussionUrl: 'https://github.com/ariesjia/vue-jsonld'
    }
    return {
      jsonld,
      description: '',
      siteAvailable: false,
      site: {
        siteName: ''
      },
      marketsAvailable: false,
      markets: []
    }
  },
  computed: {
    marketsFiltered() {
      return this.markets
        .filter(market => {
          return market.site == this.site.site
        })
        .slice(0, 1)
    },
    gpsAddress() {
      let str = this.site.siteAddress.gps
      if (str == undefined || str.length < 1) {
        str =
          this.site.siteAddress.address +
          ' ' +
          this.site.siteAddress.town +
          ' ' +
          this.site.siteAddress.postcode
      }
      return str.split(' ').join('+')
    }
  },
  mounted() {
    log.info('MarketSite mounted')

    // Get markets
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    proapps
      .getMarkets(undefined, undefined, today.toISOString())
      .then(response => {
        let markets = response

        markets = markets.filter(market => {
          return market.scheduled > new Date() || this.isToday(market.scheduled)
        })
        markets = markets.filter(market => {
          return !(market.timeFinished < new Date())
        })
        this.markets = markets.sort((a, b) => {
          return a.scheduled.getTime() - b.scheduled.getTime()
        })
        this.marketsAvailable = true
      })
      .catch(err => {
        log.error(err)
      })

    // Get sites
    proapps
      .getSite(this.$route.params.id, true)
      .then(response => {
        this.site = response
        this.siteAvailable = true
      })
      .catch(err => {
        log.error(err)
      })
  },
  destroyed() {
    log.info('MarketSite destroyed')
  },
  methods: {
    isToday(someDate) {
      const today = new Date()
      return (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      )
    }
  }
}
</script>
